<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/sub-meeting')">
        <span>จัดการห้องประชุม</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ดูข้อมูลการประชุม</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <v-divider style="background-color: #3E7662;border-width: 30px"></v-divider>
      <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
      <v-layout px-12 py-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">ชื่อการประชุม</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <textfield-form readonly hide-detail :model="form.meetingName"
                @update-data="updateData('meetingName', $event)" />
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 2 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">การประชุมครั้งที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form readonly hide-detail :model="form.meetingNumber"
                    @update-data="updateData('meetingNumber', $event)" />
                </v-flex>
                <v-flex xs6 d-flex justify-end align-center>
                  <v-layout>
                    <v-flex xs2 mr-3 shrink d-flex justify-end align-center style="color: black;font-weight: bold;">
                      <span><b>ปี</b></span>
                    </v-flex>
                    <v-flex d-flex align-center>
                      <textfield-form readonly hide-detail :model="form.meetingYear" />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 3 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">วันที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form readonly hide-detail :model="meetingDate" />
                </v-flex>
                <v-flex xs6 shrink d-flex justify-end align-center>
                  <v-layout>
                    <v-flex xs2 mr-3 d-flex justify-end align-center style="color: black;font-weight: bold;">
                      <span><b>เวลา</b></span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                      <textfield-form readonly hide-detail :model="form.meetingTime" />
                    </v-flex>
                    <v-flex shrink d-flex align-center ml-2><span><b>น.</b></span></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex shrink pr-4 style="text-align: left;" class="d-flex align-center">
              <span style="font-weight: bold;font-size: 16px;">
                ผู้เข้าร่วมงานวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(reviewer, reviewerIndex) in reviewers" :key="'reviewer_' + reviewerIndex">
                <v-layout my-1 px-12>
                  <v-flex shrink ml-6 mr-4 pt-2 class="text-end font-weight-bold">
                    <span>คนที่ {{ reviewerIndex + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select readonlyDisabled">
                    <text-autocomplete disabled id="reviewer" placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList" item-text="user_name" itemValue="user_id" :model="reviewer.userID"
                      @update-data="
                        updateData('reviewer', $event, reviewerIndex)
                        " />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout mb-6 mt-6 px-12>
            <v-flex shrink pr-4 style="text-align: left;" class="d-flex align-center">
              <span style="font-weight: bold;font-size: 16px;">
                ผู้ไม่ได้เข้าประชุมเนื่องจากติดราชการ</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(reviewer, reviewerIndex) in reviewersNotJoin" :key="'reviewer_' + reviewerIndex">
                <v-layout my-1 px-12>
                  <v-flex shrink ml-6 mr-4 pt-2 class="text-end font-weight-bold">
                    <span>คนที่ {{ reviewerIndex + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select readonlyDisabled">
                    <text-autocomplete disabled id="reviewersNotJoin" placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList" item-text="user_name" itemValue="user_id" :model="reviewer.userID"
                      @update-data="
                        updateData('reviewer', $event, reviewerIndex)
                        " />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout mb-6 mt-6 px-12>
            <v-flex shrink pr-4 style="text-align: left;" class="d-flex align-center">
              <span style="font-weight: bold;font-size: 16px;">
                ผู้เข้าร่วมสังเกตุการณ์</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(reviewer, reviewerIndex) in reviewersObserver" :key="'reviewer_' + reviewerIndex">
                <v-layout my-1 px-12>
                  <v-flex shrink ml-6 mr-4 pt-2 class="text-end font-weight-bold">
                    <span>คนที่ {{ reviewerIndex + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select readonlyDisabled">
                    <text-autocomplete disabled id="reviewersObserver" placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList" item-text="user_name" itemValue="user_id" :model="reviewer.userID"
                      @update-data="
                        updateData('reviewer', $event, reviewerIndex)
                        " />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <!-- blog 4 -->
          <v-layout mt-6 px-12>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                สถานที่
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form readonly :rows="2" :model="form.meetingPlace"
                @update-data="updateData('meetingPlace', $event)"></textarea-form>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 1 </span>
              <span style="font-weight: bold;">เรื่องแจ้ง โดยประธานคณะอนุกรรมการฯ</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex class="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="70%">เนื้อหา</th>
                      <th width="30%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody v-if="form.firstAgenda">
                    <tr v-for="(item, index) in form.firstAgenda" :key="index">
                      <td>{{ item.firstAgenda }}</td>
                      <td>
                        <a style="color: #CC3D45; text-decoration: none" target="_blank" :href="item.filePath">
                          {{ item.file ? item.file : "-" }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 2 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 2 </span>
              <span style="font-weight: bold;">ตรวจสอบองค์ประชุม</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="20%">อัตราส่วน ชาย : หญิง</th>
                      <th width="20%">
                        อัตราส่วน health science : non-health science
                      </th>
                      <th width="20%">อัตราส่วน affiliated : non-affiliated</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="10%">ผลการประชุม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">
                        {{ genderRatio.male }} : {{ genderRatio.female }}
                      </td>
                      <td class="text-center">
                        {{ scientistRatio.scientist }} :
                        {{ scientistRatio.non }}
                      </td>
                      <td class="text-center">
                        {{ affiliationRatio.affiliation }} :
                        {{ affiliationRatio.non }}
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank"
                          :href="form.secondAgendaFilePath">{{
                            form.secondAgendaFile ? form.secondAgendaFile : "-"
                          }}</a>
                      </td>
                      <td>
                        {{
                          form.secondAgendaResult == 1
                            ? "รับทราบ"
                            : form.secondAgendaResult == 0
                              ? "ไม่รับทราบ"
                              : "-"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 3 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 3 </span>
              <span style="font-weight: bold;">การมีผลประโยชน์ทับซ้อน (Conflict of interest)</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="50%">เนื้อหา</th>
                      <th width="30%">ไฟล์แนบ</th>
                      <th width="20%">ผลการประชุม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-html="form.thirdAgenda"></td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank"
                          :href="form.thirdAgendaFilePath">{{
                            form.thirdAgendaFile ? form.thirdAgendaFile : "-"
                          }}</a>
                      </td>
                      <td>
                        {{
                          form.thirdAgendaResult == 1
                            ? "รับทราบ"
                            : form.thirdAgendaResult == 0
                              ? "ไม่รับทราบ"
                              : "-"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 4 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4 </span>
              <span style="font-weight: bold;">รับรองวาระการประชุม</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <p class="text-left">
                {{
                  form.fourthAgendaResult === "1" ? "- รับรอง" : "- ไม่รับรอง"
                }}
              </p>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 5 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 5 </span>
              <span style="font-weight: bold;">รับรองรายงานการประชุมครั้งที่ผ่านมา</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">ชื่อการประชุม</th>
                      <th width="10%">รอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in fifthAgenda" :key="item.id">
                      <td>
                        {{ item.meeting ? item.meeting.meetingName : "-" }}
                      </td>
                      <td>
                        {{
                          item.meeting
                            ? "รอบที่ " +
                            item.meeting.meetingNumber +
                            " / " +
                            item.meeting.meetingDate
                            : "-"
                        }}
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank" :href="item.filePath">{{
                          item.file ? item.file : "-" }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>

          <!-- วาระที่ 6 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 6 </span>
              <span style="font-weight: bold;">เรื่องที่จะพิจารณา</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">6.1 </span>
              <span style="font-weight: bold;">รายงานผลการพิจารณาเพื่อรับรองในที่ประชุม</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">เรื่อง</th>
                      <th width="10%">รหัสโครงการ</th>
                      <th width="40%">ชื่อโครงการ</th>
                      <th width="10%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in sixthAgenda" :key="item.id">
                      <td>
                        {{ item.title ? item.title : "-" }}
                      </td>
                      <td>
                        {{ item.research ? item.research.researchCode : "-" }}
                      </td>
                      <td>
                        <a v-if="item.research" :href="'/view-research?id=' + item.research.researchID
                          " target="_blank">{{
                            item.research ? item.research.thResearchName : "-"
                          }}</a>
                        <span v-if="!item.research">-</span>
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank" :href="item.filePath">{{
                          item.file ? item.file : "-" }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <!-- วาระที่ 6.2 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">6.2 </span>
              <span style="font-weight: bold;">การพิจารณาโครงร่างการวิจัย</span>
            </v-flex>
          </v-layout>
          <!-- วาระที่ 6.2.1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">6.2.1 </span>
              <span style="font-weight: bold;">โครงร่างการวิจัยที่ขอรับรองครั้งแรก (Protocol for Initial
                Review)</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex v-if="form.hasSeventh === '1'">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">รหัสโครงการ</th>
                      <th width="40%">ชื่อโครงการ</th>
                      <th width="10%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in seventhAgenda" :key="item.id">
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.researchCode : "-"
                        }}</a>
                      </td>
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.thResearchName : "-"
                        }}</a>
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank" :href="item.filePath">{{
                          item.file ? item.file : "-" }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex v-else>
              <p class="text-left">- ไม่มี</p>
            </v-flex>
          </v-layout>
          <!-- วาระที่ 6.2.2 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">6.2.2 </span>
              <span style="font-weight: bold;">โครงร่างการวิจัยที่ปรับแก้ไขและนําเข้าพิจารณาใหม่
                (Re-Submission)</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex v-if="form.hasEighth === '1'">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">รหัสโครงการ</th>
                      <th width="40%">ชื่อโครงการ</th>
                      <th width="10%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in eighthAgenda" :key="item.id">
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.researchCode : "-"
                        }}</a>
                      </td>
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.thResearchName : "-"
                        }}</a>
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank" :href="item.filePath">{{
                          item.file ? item.file : "-" }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex v-else>
              <p class="text-left">- ไม่มี</p>
            </v-flex>
          </v-layout>
          <!-- วาระที่ 6.2.3 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">6.2.3 </span>
              <span style="font-weight: bold;">โครงร่างการวิจัยที่รับการประเมินแบบ Expedited
                และอนุกรรมการฯผู้ทบทวนขอ นําเข้าพิจารณาในที่ประชุม full
                board</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex v-if="form.hasNinth === '1'">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">รหัสโครงการ</th>
                      <th width="40%">ชื่อโครงการ</th>
                      <th width="10%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in ninthAgenda" :key="item.id">
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.researchCode : "-"
                        }}</a>
                      </td>
                      <td>
                        <a :href="'/view-research?id=' + item.research.id" target="_blank">{{
                          item.research ? item.research.thResearchName : "-"
                        }}</a>
                      </td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank" :href="item.filePath">{{
                          item.file ? item.file : "-" }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex v-else>
              <p class="text-left">- ไม่มี</p>
            </v-flex>
          </v-layout>
          <!-- วาระที่ 7 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 7 </span>
              <span style="font-weight: bold;">เรื่องอื่นๆ</span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex class="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="70%">เนื้อหา</th>
                      <th width="30%">ไฟล์แนบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-html="form.eleventhAgenda"></td>
                      <td>
                        <a style="color: #CC3D45;text-decoration: none" target="_blank"
                          :href="form.eleventhAgendaFilePath">{{
                            form.eleventhAgendaFile
                              ? form.eleventhAgendaFile
                              : "-"
                          }}</a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-flex xs6 shrink d-flex justify-end align-center>
        <v-layout>
          <v-flex xs2 mr-3 d-flex justify-end align-center style="color: black;font-weight: bold;">
            <span><b>ปิดการประชุม เวลา</b></span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <textfield-form readonly hide-detail :model="form.meetingEndTime" />
          </v-flex>
          <v-flex shrink d-flex align-center ml-2><span><b>น.</b></span></v-flex>
        </v-layout>
      </v-flex>
      <v-layout mt-12 v-if="pathResult">
        <v-flex>
          <v-btn :href="pathResult" color="#3E7662" dark>
            ผลการพิจารณาโครงร่างการวิจัย
          </v-btn>
        </v-flex>
      </v-layout>
      <v-divider class="mt-12" style="background-color: #544A44;border-width: 2px"></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-start>
        <v-btn color="#FFFFFF" @click="$router.push('/sub-meeting')">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="false"></loading>
  </v-content>
</template>

<script>
import vSelect from "vue-select";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Timeselector from "vue-timeselector";
import { mapState, mapActions } from "vuex";
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import FileInputForm from "../../components/input/FileInputForm";
import TextfieldForm from "../../components/input/TextfieldForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "EditSubMeeting",
  components: {
    TextareaForm,
    TextfieldForm,
    VueEditor,
    DateInputForm,
    Loading,
    FileInputForm,
    Timeselector,
    VueTimepicker,
    vSelect,
    TextAutocomplete,
  },
  computed: {
    years() {
      this.year = new Date().getFullYear();
      return Array.from(
        { length: this.year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      meetingName: "",
      meetingNumber: "",
      meetingYear: "2563",
      meetingDate: "",
      meetingTime: "",
      meetingEndTime: "",
      meetingPlace: "",
      firstAgenda: [
        {
          name: "",
          file: "",
          firstAgenda: "",
          filePath: "",
        },
      ],
      firstAgendaFile: "",
      firstAgendaFilePath: "",
      secondAgenda: "",
      secondAgendaResult: "0",
      secondAgendaFile: "",
      secondAgendaFilePath: "",
      thirdAgenda: "",
      thirdAgendaResult: "0",
      thirdAgendaFile: "",
      thirdAgendaFilePath: "",
      fourthAgendaResult: "",
      eleventhAgenda: "",
      eleventhAgendaFile: "",
      eleventhAgendaFilePath: "",
      hasSeventh: "0",
      hasEighth: "0",
      hasNinth: "0",
    },
    reviewers: [
      {
        userID: "",
      },
    ],
    reviewersNotJoin: [
      {
        userID: "",
      },
    ],
    reviewersObserver: [
      {
        userID: "",
      },
    ],
    // firstAgenda: [
    //   {
    //     hasFirsAgenda: "0",
    //     researchFisrtAgenda: "",
    //     FirstAgendaDescription: "",
    //     file: ""
    //   },
    // ],
    fourthAgenda: [
      {
        hasFourthAgenda: "0",
        researchFourthAgenda: "",
        fourthAgendaDescription: "",
        file: "",
        result: "0",
      },
    ],
    fifthAgenda: [
      {
        hasFifthAgenda: "0",
        researchFifthAgenda: "",
        fifthAgendaDescription: "",
        file: "",
        filePath: "",
        result: "0",
      },
    ],
    sixthAgenda: [
      {
        hasSixthAgenda: "0",
        researchSixthAgenda: "",
        sixthAgendaDescription: "",
        file: "",
        title: "",
      },
    ],
    seventhAgenda: [
      {
        hasSeventhAgenda: "0",
        researchSeventhAgenda: "",
        seventhAgendaDescription: "",
        file: "",
      },
    ],
    eighthAgenda: [
      {
        hasEighthAgenda: "0",
        researchEighthAgenda: "",
        eighthAgendaDescription: "",
        file: "",
      },
    ],
    ninthAgenda: [
      {
        hasNinthAgenda: "0",
        researchNinthAgenda: "",
        ninthAgendaDescription: "",
        file: "",
      },
    ],
    meetingDate: "",
    researchList: [],
    yearsList: [],
    sixthAgendaData: [],
    seventhAgendaData: [],
    eighthAgendaData: [],
    ninthAgendaData: [],
    reviewerList: [],
    reviewersDelete: [],
    genderRatio: {
      male: 0,
      female: 0,
    },
    scientistRatio: {
      scientist: 0,
      non: 0,
    },
    affiliationRatio: {
      affiliation: 0,
      non: 0,
    },
    pathResult: "",
  }),
  async created() {
    await this.getReviewerList();
    await this.getInitialResearch();
    await this.getMeet();
  },
  methods: {
    updateData(name, val, index = 0) {
      if (name === "reviewer") {
        this.reviewers[index].userID = val;
      } else {
        this.form[name] = val;
      }
    },
    updateDate(name, val) {
      if (name === "meetingDate") {
        this.form.meetingDate = val.date;
        this.meetingDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateDataContinue(name, index, val) {
      switch (val) {
        case "rf12":
          this.researchConList = this.researchAmendmentsList;
          this.continues[index].researchID = "";
          break;
        case "rf04_2":
          this.researchConList = this.researchAdverseEventsList;
          this.continues[index].researchID = "";
          break;
        case "rf04_1":
          this.researchConList = this.researchAdverseDrugEventsList;
          this.continues[index].researchID = "";
          break;
        case "rf05":
          this.researchConList = this.researchDeviationsList;
          this.continues[index].researchID = "";
          break;
      }
      this.continues[index][name] = val;
    },
    updateDataAmendment(name, index, val) {
      this.amendments[index][name] = val;
    },
    updateDataAdverseEvents(name, index, val) {
      this.adverseEvents[index][name] = val;
    },
    updateDataAdverseDrugEvents(name, index, val) {
      this.adverseDrugEvents[index][name] = val;
    },
    updateDataDeviations(name, index, val) {
      this.deviations[index][name] = val;
    },
    // get Initial Research List for Selection
    getInitialResearch() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getInitialResearchList")
        .then((res) => {
          this.isLoading = false;
          this.listRF = res;
          res.amendment.forEach((data) => {
            this.researchAmendmentsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
            });
          });
          res.adverseEvent.forEach((data) => {
            this.researchAdverseEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
            });
          });
          res.adverseDrugEvent.forEach((data) => {
            this.researchAdverseDrugEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
            });
          });
          res.deviation.forEach((data) => {
            this.researchDeviationsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    getMeet() {
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getMeetForView", this.$route.query.id)
        .then(async (res) => {
          console.log(res);
          this.form.meetingName = res.meetingName;
          this.form.hasSeventh = res.hasSeventh;
          this.form.hasEighth = res.hasEighth;
          this.form.hasNinth = res.hasNinth;
          this.form.secondAgendaResult = res.secondAgendaResult;
          this.form.thirdAgendaResult = res.thirdAgendaResult;
          this.form.meetingNumber = res.meetingNumber;
          this.form.meetingYear = res.meetingYear;
          this.form.meetingDate = res.meetingDate;
          this.meetingDate = this.changeDate(res.meetingDate);
          this.form.meetingTime = res.meetingTime;
          this.form.meetingEndTime = res.meetingEndTime;
          this.form.meetingPlace = res.meetingPlace;
          this.form.secondAgenda = res.secondAgenda;
          this.form.secondAgendaFile = res.secondAgendaFile;
          this.form.secondAgendaFilePath = res.secondAgendaFilePath;
          this.form.thirdAgenda = res.thirdAgenda
            ? res.thirdAgenda.replace(/\n/g, "<br>")
            : "-";
          this.form.thirdAgendaFile = res.thirdAgendaFile;
          this.form.thirdAgendaFilePath = res.thirdAgendaFilePath;
          this.form.fourthAgendaResult = res.fourthAgendaResult;
          this.form.eleventhAgenda = res.eleventhAgenda
            ? res.eleventhAgenda.replace(/\n/g, "<br>")
            : "-";
          this.form.eleventhAgendaFile = res.eleventhAgendaFile;
          this.form.eleventhAgendaFilePath = res.eleventhAgendaFilePath;
          this.fourthAgenda = res.fourthAgenda;
          this.fifthAgenda = res.fifthAgenda;
          this.sixthAgenda = res.sixthAgenda;
          this.seventhAgenda = res.seventhAgenda;
          this.eighthAgenda = res.eighthAgenda;
          this.ninthAgenda = res.ninthAgenda;
          this.tenthAgenda = res.tenthAgenda;
          if (typeof res.firstAgenda == "string") {
            if (this.form.firstAgenda[0]) {
              this.form.firstAgenda[0].firstAgenda = res.firstAgenda;
              this.form.firstAgenda[0].file = res.firstAgendaFile;
              this.form.firstAgenda[0].filePath = res.firstAgendaFilePath;
            }
          } else {
            this.form.firstAgenda = res.firstAgenda;
          }
          if (res.reviewers) {
            this.reviewers = await res.reviewers;
          }
          if (res.reviewersNotJoin) {
            this.reviewersNotJoin = await res.reviewersNotJoin;
          }
          if (res.reviewersObserver) {
            this.reviewersObserver = await res.reviewersObserver;
          }
          this.result = res.result;
          this.pathResult = res.pathResult;
          this.isLoading = false;
          await this.updateReviewerRatio();
        })
        .catch((e) => {
          console.log("error", e);
          this.isLoading = false;
        });
    },
    save(method) {
      this.isLoading = true;
      this.form["saveMethod"] = method;
      this.form["continues"] = this.continues;
      this.form["amendments"] = this.amendments;
      this.form["adverseEvents"] = this.adverseEvents;
      this.form["adverseDrugEvents"] = this.adverseDrugEvents;
      this.form["deviations"] = this.deviations;
      this.form["reviewers"] = this.reviewers;
      this.form["id"] = this.$route.query.id;

      this.$store
        .dispatch("Meeting/updateSubMeet", this.form)
        .then((res) => {
          Swal.fire({
            title: "บันทึกสำเร็จ",
            icon: "success",
            confirmButtonColor: "#3E7662",
          });
          this.isLoading = false;
          this.$router.push("/sub-meeting");
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // Swal.fire({
          //     title: "บันทึกไม่สำเร็จ",
          //     icon: 'warning'
          // })
          // this.isLoading = false;
        });
    },
    clearRedio(name, index) {
      if (name === "continues") {
        this.continues[index].has = "0";
        this.continues[index].researchID = "";
        this.continues[index].description = "";
        this.continues[index].researchID = "";
        this.continues[index].isApprove = "";
        this.continues[index].reviewerID = "";
        this.continues[index].rfType = "";
      }
      if (name === "amendments") {
        this.amendments[index].has = "0";
        this.amendments[index].researchID = "";
        this.amendments[index].description = "";
        this.amendments[index].researchID = "";
        this.amendments[index].isApprove = "";
        this.amendments[index].reviewerID = "";
      }
      if (name === "adverseEvents") {
        this.adverseEvents[index].has = "0";
        this.adverseEvents[index].researchID = "";
        this.adverseEvents[index].description = "";
        this.adverseEvents[index].researchID = "";
        this.adverseEvents[index].isApprove = "";
        this.adverseEvents[index].reviewerID = "";
      }
      if (name === "adverseDrugEvents") {
        this.adverseDrugEvents[index].has = "0";
        this.adverseDrugEvents[index].researchID = "";
        this.adverseDrugEvents[index].description = "";
        this.adverseDrugEvents[index].researchID = "";
        this.adverseDrugEvents[index].isApprove = "";
        this.adverseDrugEvents[index].reviewerID = "";
      }
      if (name === "deviations") {
        this.deviations[index].has = "0";
        this.deviations[index].researchID = "";
        this.deviations[index].description = "";
        this.deviations[index].researchID = "";
        this.deviations[index].isApprove = "";
        this.deviations[index].reviewerID = "";
      }
      if (name === "amendmentsIsApprove") {
        this.amendments[index].reviewerID = "";
        this.amendments[index].isApprove = "0";
      }
      if (name === "adverseEventsIsApprove") {
        this.adverseEvents[index].reviewerID = "";
        this.adverseEvents[index].isApprove = "0";
      }
      if (name === "adverseDrugEventsIsApprove") {
        this.adverseDrugEvents[index].reviewerID = "";
        this.adverseDrugEvents[index].isApprove = "0";
      }
      if (name === "deviationsIsApprove") {
        this.deviations[index].reviewerID = "";
        this.deviations[index].isApprove = "0";
      }
    },
    add(name) {
      switch (name) {
        case "continues":
          this.continues.push({
            has: "0",
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            rfType: "",
          });
          break;
        case "amendments":
          this.amendments.push({
            has: "0",
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
          });
          break;
        case "adverseEvents":
          this.adverseEvents.push({
            has: "0",
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
          });
          break;
        case "adverseDrugEvents":
          this.adverseDrugEvents.push({
            has: "0",
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
          });
          break;
        case "deviations":
          this.deviations.push({
            has: "0",
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
          });
          break;
      }
    },
    remove(index, name) {
      switch (name) {
        case "continues":
          this.continues = this.continues.filter((item, i) => i !== index);
          break;
        case "amendments":
          this.amendments = this.amendments.filter((item, i) => i !== index);
          break;
        case "adverseEvents":
          this.adverseEvents = this.adverseEvents.filter(
            (item, i) => i !== index
          );
          break;
        case "adverseDrugEvents":
          this.adverseDrugEvents = this.adverseDrugEvents.filter(
            (item, i) => i !== index
          );
          break;
        case "deviations":
          this.deviations = this.deviations.filter((item, i) => i !== index);
          break;
      }
    },
    addReviewer(index) {
      this.reviewers.push({ userID: "" });
    },
    async updateReviewerRatio() {
      await this.reviewers.forEach(async (reviewerData) => {
        let reviewer = await this.reviewerList.find(
          (i) => i.user_id == reviewerData.userID
        );
        if (!reviewer) {
          return;
        } else {
          if (reviewer.gender === 1) this.genderRatio.male += 1;
          else this.genderRatio.female += 1;
          if (reviewer.isScientist === 1) this.scientistRatio.scientist += 1;
          else this.scientistRatio.non += 1;

          if (reviewer.isAffiliated === 1)
            this.affiliationRatio.affiliation += 1;
          else this.affiliationRatio.non += 1;
        }
      });
    },
    removeReviewer(index) {
      this.reviewers = this.reviewers.filter((item, i) => i !== index);
    },
    async getReviewerList() {
      this.isLoading = true;
      await this.$store
        .dispatch("User/getReviewerList")
        .then((res) => {
          this.isLoading = false;
          res.forEach((data) => {
            this.reviewerList.push({
              user_id: data.id,
              user_name: data.thName,
              gender: data.gender,
              isScientist: data.isScientist,
              isAffiliated: data.isAffiliated,
              affiliation: data.affiliation,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    convertToRtf(plain) {
      plain = plain.replace(/\n/g, "\\par\n");
      return (
        "{\\rtf1\\ansi\\ansicpg1252\\deff0\\deflang2057{\\fonttbl{\\f0\\fnil\\fcharset0 Microsoft Sans Serif;}}\n\\viewkind4\\uc1\\pard\\f0\\fs17 " +
        plain +
        "\\par\n}"
      );
    },
    convertToPlain(rtf) {
      rtf = rtf.replace(/\\par[d]?/g, "");

      return rtf
        .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "")
        .trim();
    },
  },
};
</script>
<style lang="scss">
.readonlyDisabled {
  .v-input__slot {
    background-color: #3e7662 !important;
  }

  .theme--dark.v-input,
  .theme--dark.v-input input,
  .theme--dark.v-input textarea {
    color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.vue__time-picker input.display-time {
  background-color: #3e7662;
  color: white;
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}

.clear-card:hover {
  cursor: pointer;
  background-color: #f5a9a9;
}

th {
  background-color: #3e7662;
  color: white !important;
  border-left: thin solid black !important;
  border-top: thin solid black !important;
  border-bottom: thin solid black !important;
}

th:last-child {
  border-right: thin solid black !important;
}

td {
  color: black !important;
  border-left: thin solid black !important;
  border-bottom: thin solid black !important;
}

td:last-child {
  border-right: thin solid black !important;
}

td,
th {
  padding: 10px !important;
}
</style>
